import config from '../../config/config';

export const CREATE_ACCOUNT_LOAD = 'SIGN_UP/CREATE_ACCOUNT_LOAD';
export const CREATE_ACCOUNT_FAILURE = 'SIGN_UP/CREATE_ACCOUNT_FAILURE';
export const CREATE_ACCOUNT_SUCCESS = 'SIGN_UP/CREATE_ACCOUNT_SUCCESS';

export function createAccountFailureActionCreator(error) {
    return {
        error,
        type: CREATE_ACCOUNT_FAILURE
    };
}

export function createAccount(accountName, merchantName, accountAdminEmail, firstName, lastName, websiteUrl) {
    const body = {
        accountName,
        merchantName,
        accountAdminEmail,
        firstName,
        lastName,
        websiteUrl
    };

    return {
        failureActionTypeOrCreator: createAccountFailureActionCreator,
        fetchParams: {
            method: 'POST',
            url: `${config.userManagementApiUrl}/public/preconfigureAccount`,
            body
        },
        loadActionTypeOrCreator: CREATE_ACCOUNT_LOAD,
        successActionTypeOrCreator: CREATE_ACCOUNT_SUCCESS,
        forceSkipTokenMiddleware: true
    };
}
